// extracted by mini-css-extract-plugin
export default {"wrapper":"yz-z","response":"zz-z","error":"Az-z","disabled":"Bz-z","buttons":"Cz-z","feedbackQuestionSection":"Dz-z","yesNoWrapper":"Ez-z"};